import HTMLTemplate from './template.html'
import './styles.scss'

export const AirportPopupComponent = (() => {
    const vueComponent = {
        data() {
            return {
                airportCode: '',
                airportName: '',
                city: '',
                country: '',
                leftPosition: 0,
                topPosition: 0,
                display: 'none',
                opacity: 0,
                cityRating: 0,
                countryRating: 0,
                airportRating: 0,
                airspaceRating: 0
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-airport-popup')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
